import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55736dca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "notifications-container"
}
const _hoisted_2 = {
  key: 0,
  class: "menu-item_title"
}

import {computed, ExtractPropTypes, AnchorHTMLAttributes} from 'vue';
    import {bool, number, object, string} from 'vue-types';
    import {NotificationBadge} from '@/logged/features/notifications';
    import {NavigationTab, useAsideMenu} from '@/logged/features/aside-menu';
    import TootipWrapper from './TootipWrapper.vue';
    import {SvgIcon} from '@/logged/common/ui';
    import {useHover, useDisplayMobile} from '@/logged/common/composables';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderMenuItem',
  props: {
        tab: object<NavigationTab>(),
        icon: string(),
        title: string(),
        showTitle: bool().def(true),
        canBeActive: bool().def(true),
        size: number().def(20),
    },
  setup(__props) {

const props = __props;

    

    const asideMenuStore = useAsideMenu();
    const {isDisplayMobile} = useDisplayMobile();
    const getIcon = computed(() => (props.tab?.icons?.mainIcon ?? props.icon)!);
    const getTitle = computed(() => (props.tab?.title ?? props.title)!);

    const {isHovering} = useHover();

    const getComponentRoot = computed<'div' | 'a' | typeof TootipWrapper>(() => {
        if (props.tab?.tooltip) {
            return TootipWrapper;
        } else if (props.tab?.url?.href) {
            return 'a';
        }
        return 'div';
    });

    const isActive = computed(() => !!props.tab?.id && asideMenuStore.currentActiveRoute === props.tab.id);

    const getNotificationCount = computed(() => props.tab?.notificationsCount);

    const getComputedAttrs = computed<Partial<AnchorHTMLAttributes> | ExtractPropTypes<typeof TootipWrapper>>(() => {
        if (props.tab?.tooltip) {
            return {content: props.tab.tooltip, url: props.tab.url};
        } else if (props.tab?.url?.href) {
            return {
                href: props.tab.url.href,
                ...(props.tab.url.blank && {target: '_blank'}),
                ...(props.tab.url.heapId && {'data-heap': props.tab.url.heapId}),
            };
        }
        return {};
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(getComponentRoot)), _mergeProps({ class: "menu-item flex" }, _unref(getComputedAttrs), {
    "aria-label": _unref(getTitle),
    "data-test-id": __props.tab?.id,
    class: {isActive: _unref(isActive)}
  }), {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["menu-item_icon-wrapper", {isActive: _unref(isActive)}])
      }, [
        _createVNode(_unref(SvgIcon), {
          active: _unref(isActive) || (_unref(isHovering) && __props.canBeActive),
          src: _unref(getIcon),
          name: __props.tab?.id ?? _unref(getTitle),
          "can-be-active": __props.canBeActive,
          size: __props.size
        }, null, 8, ["active", "src", "name", "can-be-active", "size"]),
        (_unref(getNotificationCount))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_unref(NotificationBadge), {
                count: _unref(getNotificationCount),
                offset: 0
              }, null, 8, ["count"])
            ]))
          : _createCommentVNode("", true)
      ], 2),
      (__props.showTitle && !_unref(isDisplayMobile))
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(getTitle)), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16, ["aria-label", "data-test-id", "class"]))
}
}

})